<template>
  <div :class="classes"><slot></slot></div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

type Props = {
  strong?: boolean
  class?: string
}

const props = defineProps<Props>()

const classes = computed(() => ({
  'app-divider': true,
  'app-divider--strong': props.strong,
  [`${props.class}`]: !!props.class,
}))
</script>
